import { render } from "./CreatorsReviews.vue?vue&type=template&id=2c9b7dc7&scoped=true"
import script from "./CreatorsReviews.vue?vue&type=script&lang=js"
export * from "./CreatorsReviews.vue?vue&type=script&lang=js"

import "./CreatorsReviews.vue?vue&type=style&index=0&id=2c9b7dc7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9b7dc7"]])

export default __exports__